"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableProject = exports.TablePlacePageHeader = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var DataQualityWarningTables_1 = require("../DataQualityWarnings/DataQualityWarningTables");
var LabelsHookHelper_1 = require("../DataQualityWarnings/LabelsHookHelper");
var PlaceHeaderMetadataCertification_1 = require("../placePage/PlaceHeaderMetadataCertification");
var PlaceHeaderMetadataProject_1 = require("../placePage/PlaceHeaderMetadataProject");
var PlaceHeaderMetadataTableauUser_1 = require("../placePage/PlaceHeaderMetadataTableauUser");
var PlacePageIconContainer_1 = require("../placePage/PlacePageIconContainer");
var CreateWorkbookFromCatalogButtons_1 = require("./CreateWorkbookFromCatalogButtons");
function TablePlacePageHeader(props) {
    var uiActions = react_1.default.useContext(data_catalog_shared_1.UIActionsContext);
    var siteUrls = react_1.default.useContext(data_catalog_shared_1.SiteUrlsContext);
    var editingIsEnabled = props.apiRequests.isSiteCreatorOrHigher() && !props.hideLaunchEditOnMobile;
    var canCreateFlowFromTable = editingIsEnabled && !!props.newFlowFromCatalog;
    var dbclass = props.table && props.table.database && props.table.database.connectionType;
    var sendCreateEvent = (0, data_catalog_shared_1.useTelemetrySender)({ type: '', content_type: '', data_type: '', connection_type: '' });
    var _a = (0, LabelsHookHelper_1.useRenderLabelsDC3)({ category: 'all', itemInfo: props.table, masthead: true }), warnings = _a.warnings, certifications = _a.certifications;
    return (react_1.default.createElement(data_catalog_shared_1.FeatureFlagsContext.Consumer, null, function (featureFlags) {
        return react_1.default.createElement(data_catalog_shared_1.PlacePageHeader, null,
            react_1.default.createElement(data_catalog_shared_1.PlacePageTitleContainer, null,
                react_1.default.createElement(PlacePageIconContainer_1.PlacePageIconContainer, { title: Localize_1.Messages.Table() },
                    react_1.default.createElement(data_catalog_shared_1.TableMastheadIcon, null)),
                react_1.default.createElement(data_catalog_shared_1.PlacePageMastheadContainer, null,
                    react_1.default.createElement(data_catalog_shared_1.PlacePageMastheadRowContainer, null,
                        react_1.default.createElement(data_catalog_shared_1.PlacePageTitle, { title: props.table.name || undefined }, props.table.name),
                        react_1.default.createElement(data_catalog_shared_1.PlacePageActionsMenu, null, uiActions.renderTablesActionMenu(props.table))),
                    react_1.default.createElement(data_catalog_shared_1.PlacePageMastheadRowContainer, null,
                        react_1.default.createElement(TableContact, { table: props.table }),
                        featureFlags.databasesInProjectsEnabled && react_1.default.createElement(TableProject, { table: props.table, apiRequests: props.apiRequests, siteUrls: siteUrls }),
                        featureFlags.labelsInMorePlacesEnabled ?
                            react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null, certifications)
                            : react_1.default.createElement(TableCertifier, { table: props.table, siteUrls: siteUrls }),
                        featureFlags.labelsInMorePlacesEnabled ?
                            react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null, warnings)
                            : react_1.default.createElement(TableDataQualityWarningStatusChip, { table: props.table })))),
            react_1.default.createElement(CreateWorkbookFromCatalogButtons_1.CreateDocumentFromResourceButton, { apiRequests: props.apiRequests, siteUrls: siteUrls, isEmbedded: !!props.table.isEmbedded, resourceId: props.table.id, resourceType: CreateWorkbookFromCatalogButtons_1.RESOURCE_TYPE_TABLE, databaseClass: dbclass, testId: 'CreateDocumentFromTableButton', title: Localize_1.Messages.NewWorkbookButton(), canCreateWorkbook: editingIsEnabled, canCreateFlow: canCreateFlowFromTable, projectIdForNewDocuments: props.projectIdForNewDocuments, sendCreateDocumentEvent: sendCreateEvent }));
    }));
}
exports.TablePlacePageHeader = TablePlacePageHeader;
function TableContact(props) {
    var contact = props.table.__typename === 'DatabaseTable' ? props.table.contact : null;
    return (react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null,
        react_1.default.createElement(PlaceHeaderMetadataTableauUser_1.PlaceHeaderMetadataTableauUser, { tableauUser: contact, labelText: Localize_1.Messages.GridHeaderContact() })));
}
/** @deprecated TFS1478812 */
function TableCertifier(props) {
    if (props.table.__typename !== 'DatabaseTable') {
        return null;
    }
    return (react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null,
        react_1.default.createElement(PlaceHeaderMetadataCertification_1.PlaceHeaderMetadataCertification, { anchoredAsset: {
                __typename: 'DataQualityCertification',
                asset: __assign({}, props.table),
            }, subjectArea: props.table.__typename, vizportalId: props.table.vizportalId, contentId: props.table.id, certification: props.table, siteUrls: props.siteUrls, showExtractRefresh: false, dataQualityCertifications: props.table.dataQualityCertifications })));
}
/** @deprecated TFS1478812 */
function TableDataQualityWarningStatusChip(props) {
    if (props.table.__typename !== 'DatabaseTable') {
        return null;
    }
    return (react_1.default.createElement(DataQualityWarningTables_1.QueryTableOwnAndUpstreamDataQualityWarnings, { nodeId: props.table.id, source: 'TablePlacePageHeader' }));
}
function TableProject(props) {
    var _a = react_1.default.useState(), container = _a[0], setContainer = _a[1];
    react_1.default.useEffect(function () {
        props.apiRequests
            .getContainerForContent({ contentType: 'table', contentId: props.table.vizportalId })
            .then(function (container) { return setContainer(container); })
            .catch(function () { return setContainer(undefined); });
    }, [props.table, props.apiRequests]);
    return (container && container.type === 'PROJECT')
        ? (react_1.default.createElement(data_catalog_shared_1.PlaceHeaderMetadataItem, null,
            react_1.default.createElement(PlaceHeaderMetadataProject_1.PlaceHeaderMetadataProject, { projectId: container.id, projectName: container.name, siteUrls: props.siteUrls })))
        : null;
}
exports.TableProject = TableProject;
//# sourceMappingURL=TablePlacePageHeader.js.map